export default __webpack_public_path__ + "static/media/high-priority.d0cef91c.svg";